import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
declare var $: any; // TODO hide modal in othe way

import { environment } from "@environments/environment";

// Constants
import { AppConstants } from '@app/appConstants';

// Interfaces
import { ResponseDataBase } from '@interfaces/index.interface';

// Services
import { UserService } from "@services/user/user.service";
import { ResourceService } from "@services/resource/resource.service";

@Injectable()
export class AuthService {

  private _idToken: string;
  private _accessToken: string;
  private _expiresAt: number;


  backURL = environment.BACKURL;
  alert: string;
  loading: boolean;

  constructor(public router: Router,
    public http: HttpClient,
    public _userService: UserService,
    public _resourceService: ResourceService,
    public translate: TranslateService) {

    this._idToken = '';
    this._accessToken = '';
    this._expiresAt = 0;
  }

  /** Solo comprueba que efectivamente se recibe username y password y si es así intenta el logueo en getUserToken */
  loginUser(username, password) {
    this.loading = true;
    if (username && password) {
      let data = { username, password };
      this.getUserToken(data);
    } else {
      this.alert = "FILL_MAIL_AND_PASS";
      this.loading = false;
    }
  }

  /** Vacia el sessionStorage, navega al la página prncipal, limpia algunos recursos almacenados y hace llama 
  al _userService.doLogout() */
  logout() {
    this._userService.doLogout();
  }

  /** Si los datos de logueo son correctos se recupera el token y se almacena en el sessionStorage para enviarlo en todas las demás
    peticiones que haga al back. Pide los datos del usuario a traves de ._userService.getData. También comprueba si el usuario
    esta activo en la BBDD. */
  getUserToken(data) {
    this.http.post(this.backURL + 'rest/user/login', data)
      .subscribe(
        RES => {
          let response = RES as ResponseDataBase;
          if (response.METADATA.STATUS == AppConstants.STATUS.OK) {
            this._userService.token = response.result[0].token;
            sessionStorage.setItem("token", response.result[0].token);
            this._userService.getData('');
            delete this.alert;
            $('#LoginModal').modal('hide');
            this._userService.lastActivityTime = +new Date();
            let self = this;
            this._userService.checkForActivity = setInterval(function () {
              self._userService.checkForActivityAction();
            }, 1000);
          } else if (response.METADATA.STATUS == AppConstants.STATUS.RESENDACTIVATION) {
            this.alert = "PLEASE_CONFIRM_YOUR_MAIL_BEFORE_ACCESSING";
          }
          this.loading = false;
        }, err => {
          if (err.status == 409) {
            this.alert = "USER_LOCKED";
            this.loading = false;
          } else if (err.status == 410) {
            this.alert = "USER_LOG_TWICE";
            this.loading = false;
          } else {
            this.alert = "USER_OR_PASSWORD_WRONG";
            this.loading = false;
          }
        }
      );
  }
}
